import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ forArticleCard?: boolean }>`
  max-width: 37.5rem;
  margin: 0 auto;
  border-radius: 0.5rem;
  border: 2px solid ${({ theme }) => theme.palette.primary.main};

  ${({ forArticleCard }) =>
    forArticleCard &&
    css`
      border: none;
    `}
`

export const Top = styled.div<{ forArticleCard?: boolean }>`
  display: flex;
  align-items: center;
  padding: 2rem;

  & > * + * {
    margin-left: 1rem;
  }

  ${({ forArticleCard, theme }) =>
    forArticleCard &&
    css`
      padding: 0;
      padding-top: ${theme.spacing(2)};
    `}
`

export const ImageWrapper = styled.div`
  align-self: stretch;
  border-radius: 99rem;
  overflow: hidden;
  height: 3rem;
  width: 3rem;
  flex-shrink: 0;
  box-shadow: ${({ theme }) => theme.palette.shadow.main};

  & img {
    max-width: 100%;
    max-height: 100%;
  }
`

export const NameWrapper = styled.div<{ forArticleCard?: boolean }>`
  // TODO: Font should be come form theme
  font-weight: bold;
  margin-bottom: 1rem;

  ${({ forArticleCard }) =>
    forArticleCard &&
    css`
      margin-bottom: 0;
      font-weight: normal;
      color: grey;
    `}
`

export const Name = styled.span<{ forArticleCard?: boolean }>`
  ${({ forArticleCard }) =>
    forArticleCard &&
    css`
      color: ${({ theme }) => theme.palette.link.main};
    `}
`

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.75rem;

  & > * + * {
    margin-left: 0.5rem;
  }
`
